<template>
  <div class="footer-w">
    <div class="footer">
      <div class="container">
        <div class="f-l">
          <div class="f-co"><a href="/files" class="fl w-inline-block">
            <div>Informácie o rozsahu poistenia</div>
          </a><a href="/files" class="fl w-inline-block">
            <div>Tlačivá na stiahnutie</div>
          </a><a href="/files" class="fl w-inline-block">
            <div>Povinné informácie</div>
          </a></div>
          <div class="f-co"><a href="mailto:info@travelinsurance.sk" class="fl w-inline-block">
            <div class="ico fc-2 mr"></div>
            <div>info@travelinsurance.sk<br></div>
          </a><a href="#" class="fl w-inline-block">
            <div class="ico fc-2 mr"></div>
            <div>+421 917 858 738</div>
          </a></div>
          <div class="mb"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="coh mb"><a href="https://www.slovaklines.sk/" target="_blank" class="w-inline-block"><img
          src="/img/trip/webflow/682daf32f0abc53ce04d37ff_SLLogo.png"
          loading="lazy" alt="" class="ft-l"></a><img
          src="/img/trip/webflow/647f7f5aa8c5d20a54ebdde7_colonnade.png"
          loading="lazy" alt="" class="ft-l"><a href="http://bhic.sk/" target="_blank" class="w-inline-block"><img
          src="/img/trip/webflow/647f7f5942fdebf04d783069_bh.png"
          loading="lazy" alt="" class="ft-l"></a></div>
      <div class="copy">
        <div>© 2025 Travel insurance. <br>Všetky práva vyhradené.</div>
      </div>
    </div>
  </div>
  <!-- cookie warning toast -->
  <div :class="{'cookie-popup': true, 'show': show }">

    <div :class="{'toast':true,  'bg-light w-40 mw-40': true}" role="alert" data-autohide="false">
      <div class="toast-header">

        <strong class="me-auto"></strong>
        <small></small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" @click="save(0)"></button>
      </div>
      <div class="toast-body p-4 d-flex flex-column">
        <h4>Cookies</h4>
        <p>
          Táto webová stránka ukladá na Vaše zariadenie malé súbory, ktoré sú vo všeobecnosti označované ako cookies. Bližšie informácie nájdete v súbore Info GDPR. Používame iba tzv. nevyhnutné cookies, ktoré sú nevyhnutné na zabezpečenie fungovania našej webovej stránky a ich účelom je prenos alebo uľahčenie prenosu správy prostredníctvom siete. Na používanie týchto cookies sa Váš osobitný súhlas nevyžaduje.
        </p>
        <div class="ml-auto">
          <!--          <button type="button" class="btn btn-outline-light mr-3" id="btnDeny">-->
          <!--            Deny-->
          <!--          </button>-->
          <button type="button" class="btn btn-primary inverse" @click="save(1)">
            Nepovoliť
          </button>
          <button type="button" class="btn btn-primary" @click="save(1)">
            Povoliť
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieLaw from 'vue-cookie-law'
export default {
  name: "FooterPart",
  components: {

  },
  data: function (){
    return { show: false}
  },
  props: {
    product: String
  },
  methods: {
    save(val){
      localStorage.setItem('cookies', val);
      this.show = false;
    }
  },
  mounted() {
    //this.show = true;
    this.show = !localStorage.getItem('cookies');
  }
}
</script>
<style>
.cookie-popup{
  display: none;
  position: fixed;
  bottom: 20px;
  left: 20px;

  font-weight: 400;
  color: #004367;
  box-sizing: inherit;
  border: 1px solid;
  padding: 20px 26px;
  box-shadow: 0 -1px 10px 0 #acabab4d;
  border-radius: 6px;
  background-color: #FFFFFF;
  border-color: #f4f4f4;
  font-size: 0.92rem;
  line-height: 1.4;
  max-width: 500px;
}
.cookie-popup.show{
  display: block;
}
.ml-auto{
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  .inverse{
    background-color: transparent;
    color: var(--col_2);
  }
}
@media screen and (max-width: 767px) {
  .footer-w .coh {
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    row-gap: 1rem;
    column-gap: 1rem;
  }
  .copy{
    text-align: center;
    width: 100%;
  }
}



</style>

